import { ClientSession } from './session.js';
export class ReplayPlayer {
    replay;
    map;
    onEvent;
    current;
    /** Blocos de frame já aplicados (0 = só o estado inicial). */
    applied = 0;
    /** Repassa os efeitos (desligado ao pular). */
    emitting = false;
    constructor(replay, map, 
    /** Efeitos do frame (explosões, sons); não é chamado ao pular para trás ou para a frente. */
    onEvent) {
        this.replay = replay;
        this.map = map;
        this.onEvent = onEvent;
        this.reset();
    }
    /** Sessão do espectador (`me` = −1): mundo, nomes, placar... */
    get session() {
        return this.current;
    }
    /** Quantos frames o replay tem. */
    get length() {
        return this.replay.frames.length;
    }
    /** Posição atual (frames aplicados). */
    get position() {
        return this.applied;
    }
    reset() {
        const session = new ClientSession({
            send: () => { },
            onMapChange: () => session.setMap(this.map),
            onEvent: (ev) => {
                if (this.emitting)
                    this.onEvent?.(ev);
            },
        });
        session.maxPlayers = this.replay.header.maxPlayers;
        session.prediction = { enabled: false, amount: 0 };
        session.handle(this.replay.init, 0);
        this.current = session;
        this.applied = 0;
    }
    /** Aplica o próximo frame; false no fim. */
    step() {
        if (this.applied >= this.length)
            return false;
        this.emitting = true;
        this.apply(this.applied);
        return true;
    }
    apply(index) {
        const block = this.replay.frames[index];
        this.current.handle(block, (this.replay.header.startFrame + index) * 100);
        this.applied = index + 1;
    }
    /** Vai para depois de `position` frames (0..length), sem efeitos. */
    seek(position) {
        const target = Math.max(0, Math.min(this.length, Math.trunc(position)));
        if (target < this.applied)
            this.reset();
        this.emitting = false;
        while (this.applied < target)
            this.apply(this.applied);
    }
}
//# sourceMappingURL=replay.js.map